import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

function CommWindows() {
    return (
        <React.Fragment>
            <ol>
                <li>
                    Check that the SDCX server can connect to the network, and that firewall rules are set correctly.
                </li>
                <li>Ensure that the SDCX server is configured to use a time service.</li>
                <li>
                    Open the <strong>Services</strong> control panel and verify all Signiant services are running. If
                    any services are stopped, start them using the <strong>Start</strong> button.
                </li>
                <li>Restart all Signiant services.</li>
                <li>
                    Verify that the server is registered by checking for a{' '}
                    <code className="language-text">deviceID</code> in the communication service settings. Open the{' '}
                    <code className="language-text">
                        C:\Program Files\signiant\signiant-communication-service-config.json5
                    </code>{' '}
                    file and ensure <code className="language-text">deviceID</code> is present and has a value set. If
                    it is missing, use a registration key to register the server using the desktop shortcut.
                </li>
                <li>Run the Signiant SDCX Server troubleshooting script:</li>
            </ol>
            <div className="gatsby-highlight" data-language="text">
                <pre className="language-text">
                    <code className="language-text">
                        &gt; C:\Program Files\Signiant Media Shuttle\bin\signiantSDCXServerTroubleshoot.bat
                    </code>
                </pre>
            </div>
            <p>
                If no connectivity issues can be detected,{' '}
                <a href="https://support.signiant.com/hc/en-us/requests/new">contact Signiant Support</a>.
            </p>
        </React.Fragment>
    );
}

CommWindows.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CommWindows);
